// extracted by mini-css-extract-plugin
module.exports = {"brandcolor":"#163194","brandcolor2":"#2699FB","mainbackgroundcolor":"#fff","payment":"g_F","cc-card":"g_G","ccCard":"g_G"};